import { SET_PORTAL, SET_INFO } from '../../constants/index'
import { removePasscode, setPasscode } from './storage';

export const passcodeStore = store => next => action => {
  if (action.type === SET_PORTAL && action.portal && action.portal._id) {
    const state = store.getState()
    setPasscode(state.info.passcode)
  } else if(action.type === SET_INFO && action.key === 'passcode' && !action.value) {
    removePasscode()
  }
  return next(action)
}



// WEBPACK FOOTER //
// ./src/modules/passcode/middleware.js